import {http} from '../../shared/services';

export const ADD_NEW_COMMENT = 'ADD_NEW_COMMENT';
export const ADD_NEW_COMMENT_FULFILLED = 'ADD_NEW_COMMENT_FULFILLED';
export const ADD_NEW_COMMENT_PENDING = 'ADD_NEW_COMMENT_PENDING';
export const ADD_NEW_COMMENT_REJECTED = 'ADD_NEW_COMMENT_REJECTED';

export function addNewComment(model) {
  return {
    type: ADD_NEW_COMMENT,
    payload: http.post('comments', {'comment': model}),
  };
}



// WEBPACK FOOTER //
// ./app/features/comments/actions/addNewComment.js